export default {
    data: () => ({
        lendingKitModel: {
            codentify: '',
            old_codentify: '',
            child_codentify_1: '',
            child_codentify_2: '',
            lending_point_id: null,
            stock_status_id: null,
            product_model_id: null,
            product_color_id: null,
            orders_completed_count: 0,
            product_model: null,
            product_color: null,
            enable_to_creation: 1,
            owner_id: null,
            ownership: null
        }
    })
}



// WEBPACK FOOTER //
// ./resources/assets/js/pages/lendingKitModel.js